export const OnlySymbolRegExp = /^[а-яёa-z-]+$/i;

export const PhoneRegExp = /^[+]?[\d]{10,15}$/;

export const PasswordRegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!”#$%&'()*+,-./:;<=>?@[\]^_`{|}~<>№"\\])[A-Za-z\d!”#$%&'()*+,-./:;<=>?@[\]^_`{|}~№\\"]{6,}$/;

export const EmailRegExp = /^[a-zA-Z0-9.\-_]+@[a-zA-Z0-9.\-_]+\.[a-z]{2,4}$/gm;

export const cyrillicRegExp = /[а-яё]/gi;

export const OnlySymbolInputRegExp = /^[а-яёa-z-]{0,30}$/i;
export const PhoneInputRegExp = /^[+]?[\d]{0,15}$/;
export const EmailInputRegExp = /^[a-z\-_.@\d]{0,100}$/i;

export const OGRNRegexp = /^(\d{13})$/;
export const companyEmailValidation =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
